interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  jsonLd?: object | object[];
  ogImage?: string;
  noindex?: boolean;
}

// Deprecated: metadata is managed via each route's head() using buildSeo().
// This component is intentionally a no-op so it can't clobber SSR-rendered
// <title> / <meta> tags after hydration. Existing call sites are left in
// place; they simply render nothing.
export function SEOHead(_props: SEOHeadProps) {
  return null;
}